import React from 'react';
import { Common } from '@stockbit/ui';

import { ListContainer } from '../styled';
import ListCloseIcon from './ListCloseIcon';
import { Watchlist } from '../../../../../../@types/watchlist';

type WatchlistItemProps = {
  id: Watchlist['watchlist_id'];
  name: Watchlist['name'];
  index: number;
  hoveredRow: number | null;
  onHover: (hoveredIndex: number | null) => void;
  onClick: (id: string) => void;
};

const { Text } = Common;

function WatchlistItem({
  id,
  index,
  name,
  hoveredRow,
  onHover,
  onClick,
}: WatchlistItemProps) {
  const handleItemClick = () => {
    onClick(id);
  };

  const handleMouseEnter = () => {
    onHover(index);
  };

  const handleMouseLeave = () => {
    onHover(null);
  };

  return (
    <ListContainer
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Text
        size="12px"
        height="30px"
        style={{ flex: 1 }}
        onClick={handleItemClick}
      >
        {name}
      </Text>
      {hoveredRow === index && index !== 0 && <ListCloseIcon id={id} />}
    </ListContainer>
  );
}

export default WatchlistItem;
